// Copyright (c) 2025 Deere & Company

export default Object.freeze({
    RESET_RGA_RESULTS_NAVIGATION: 'RESET_RGA_RESULTS_NAVIGATION',
    RESET_RGA_SEARCH_FORM_SELECTED_DOMAINS: 'RESET_RGA_SEARCH_FORM_SELECTED_DOMAINS',
    RESET_RGA_SEARCH_MODEL_LIST_OBJECT_VALUES: 'RESET_RGA_SEARCH_MODEL_LIST_OBJECT_VALUES',
    RESET_RGA_SEARCH_MODEL_OBJECT: 'RESET_RGA_SEARCH_MODEL_OBJECT',
    RESET_RGA_SEARCH_MODEL_OBJECT_DATE_VALUES: 'RESET_RGA_SEARCH_MODEL_OBJECT_DATE_VALUES',
    RESET_RGA_SEARCH_MODEL_OBJECT_VALUES: 'RESET_RGA_SEARCH_MODEL_OBJECT_VALUES',
    SET_REQUEST_DATE_SEARCH_MODEL: 'SET_REQUEST_DATE_SEARCH_MODEL',
    SET_SELECTED_RGA_LIST_MASS_UPDATE: 'SET_SELECTED_RGA_LIST_MASS_UPDATE',
    UPDATE_RGA_ADDITIONAL_DATA_COMMENTS: 'UPDATE_RGA_ADDITIONAL_DATA_COMMENTS',
    UPDATE_RGA_ADDITIONAL_DATA_INFO: 'UPDATE_RGA_ADDITIONAL_DATA_INFO',
    UPDATE_RGA_ADDITIONAL_DATA_INFO_FLAG: 'UPDATE_RGA_ADDITIONAL_DATA_INFO_FLAG',
    UPDATE_RGA_ADDITIONAL_DATA_TEST_DOMAIN: 'UPDATE_RGA_ADDITIONAL_DATA_TEST_DOMAIN',
    UPDATE_RGA_ADDITIONAL_DATA_TEST_SELECTED_DOMAIN: 'UPDATE_RGA_ADDITIONAL_DATA_TEST_SELECTED_DOMAIN',
    UPDATE_RGA_ADDITIONAL_DATA_TYPE_DOMAIN: 'UPDATE_RGA_ADDITIONAL_DATA_TYPE_DOMAIN',
    UPDATE_RGA_ANALYSIS_STATUS_DROPDOWN: 'UPDATE_RGA_ANALYSIS_STATUS_DROPDOWN',
    UPDATE_RGA_CONSIGNMENT_DETAILS: 'UPDATE_RGA_CONSIGNMENT_DETAILS',
    UPDATE_RGA_CONSTANT_DROPDOWN_RGA_STATUS: 'UPDATE_RGA_CONSTANT_DROPDOWN_RGA_STATUS',
    UPDATE_RGA_CONSTANT_DROPDOWN_RGA_UNIT: 'UPDATE_RGA_CONSTANT_DROPDOWN_RGA_UNIT',
    UPDATE_RGA_DEALER_DETAILS: 'UPDATE_RGA_DEALER_DETAILS',
    UPDATE_RGA_DETAILS: 'UPDATE_RGA_DETAILS',
    UPDATE_RGA_FILE_DETAILS: 'UPDATE_RGA_FILE_DETAILS',
    UPDATE_RGA_Q_AND_A_DETAILS: 'UPDATE_RGA_Q_AND_A_DETAILS',
    UPDATE_RGA_REQUESTOR_TYPE_DROPDOWN: 'UPDATE_RGA_REQUESTOR_TYPE_DROPDOWN',
    UPDATE_RGA_RESULTS_NAVIGATION: 'UPDATE_RGA_RESULTS_NAVIGATION',
    UPDATE_RGA_RETURNED_ANALYSIS_VALUES: 'UPDATE_RGA_RETURNED_ANALYSIS_VALUES',
    UPDATE_RGA_RETURNED_CONSIGNMENT_VALUES: 'UPDATE_RGA_RETURNED_CONSIGNMENT_VALUES',
    UPDATE_RGA_RETURNED_DEALER_INFO_VALUES: 'UPDATE_RGA_RETURNED_DEALER_INFO_VALUES',
    UPDATE_RGA_SEARCH_BY: 'UPDATE_RGA_SEARCH_BY',
    UPDATE_RGA_SEARCH_LIST_FILTER_BY: 'UPDATE_RGA_SEARCH_LIST_FILTER_BY',
    UPDATE_RGA_SEARCH_LIST_SORT_BY: 'UPDATE_RGA_SEARCH_LIST_SORT_BY',
    UPDATE_RGA_SEARCH_LIST_SORT_DIRECTION: 'UPDATE_RGA_SEARCH_LIST_SORT_DIRECTION',
    UPDATE_RGA_SEARCH_MODEL_LIST_OBJECT: 'UPDATE_RGA_SEARCH_MODEL_LIST_OBJECT',
    UPDATE_RGA_SEARCH_MODEL_OBJECT: 'UPDATE_RGA_SEARCH_MODEL_OBJECT',
    UPDATE_RGA_SEARCH_MODEL_OBJECT_DD_VALUES: 'UPDATE_RGA_SEARCH_MODEL_OBJECT_DD_VALUES',
    UPDATE_RGA_SEARCH_QUERY_STRING: 'UPDATE_RGA_SEARCH_QUERY_STRING',
    UPDATE_RGA_SEARCH_RESULTS: 'UPDATE_RGA_SEARCH_RESULTS',
    UPDATE_RGA_SEARCH_RESULTS_FLAG: 'UPDATE_RGA_SEARCH_RESULTS_FLAG',
    UPDATE_RGA_SEARCH_SELECT_DOMAIN_VALUE: 'UPDATE_RGA_SEARCH_SELECT_DOMAIN_VALUE',
    UPDATE_RGA_SELECTED_MASS_UPDATE: 'UPDATE_RGA_SELECTED_MASS_UPDATE',
    UPDATE_RGA_STATUS_DROPDOWN: 'UPDATE_RGA_STATUS_DROPDOWN',
    UPDATE_RGA_UNIT_DROPDOWN: 'UPDATE_RGA_UNIT_DROPDOWN'
});



// WEBPACK FOOTER //
// ./src/rga/actions-list.js